import { Injectable, signal } from '@angular/core';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ApiClientService, ApiResponse } from '@core/services/api-client.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class settingsService {
  private readonly COMPANY_ID = 'UNITYCRM0021';
  constructor(
    private apiClient: ApiClientService,
    private http: HttpClient
  ) {}
private getCurrentUserId(): string {
  const userDetailsString = localStorage.getItem('userDetails');
  try {
    const userDetails = JSON.parse(userDetailsString || '{}');
    return userDetails.userID?.toString() || 'default-user';
  } catch (error) {
    console.error('Error parsing userDetails from localStorage:', error);
    return 'default-user';
  }
}
  getAllUsers(obj: any): Observable<any> {
    const requestBody = {
      companyId: this.COMPANY_ID,
      userID: this.getCurrentUserId(),
      per_page: 10,
      ...obj,
    };

    return this.apiClient
      .get('api/unity/get-users', {
        params: requestBody,
      })
      .pipe(map(response => response.data));
  }
  getUserProfileDetails(userId: number): Observable<any> {
    let obj = {
      companyId: this.COMPANY_ID,
      userID: this.getCurrentUserId(),
    };

    let url = `api/unity/viewAccountDetail/${userId}`;
    return this.apiClient.get(url);
  }
  getgroupslist(AGENTS, obj?: any): Observable<any> {
    const requestBody = {
      companyId: this.COMPANY_ID,
      userID: this.getCurrentUserId(),
      groupTypeName: AGENTS,
      ...obj,
    };

    return this.apiClient
      .get('api/system/groups-list', {
        params: requestBody,
      })
      .pipe(map(response => response.data));
  }
  getApplist(): Observable<any> {
    const requestBody = {
      companyId: this.COMPANY_ID,
      userID: this.getCurrentUserId(),
    };

    return this.apiClient
      .get('api/unity/getAqsaTelApps', {
        params: requestBody,
      })
      .pipe(map(response => response.data));
  }
  createNewUser(payload: any): Observable<any> {
    const requestBody = {
      ...payload,
      companyId: this.COMPANY_ID,
      // userID: this.getCurrentUserId()
    };

    return this.apiClient
      .post('api/unity/create-user', requestBody)
      .pipe(map(response => response.data));
  }
  updateUser(payload: any): Observable<any> {
    const requestBody = {
      ...payload,
      companyId: this.COMPANY_ID,
      // userID: this.getCurrentUserId()
    };

    return this.apiClient
      .put(`api/unity/update-user`, requestBody)
      .pipe(map(response => response.data));
  }

  changeUserPassword(payload: any): Observable<any> {
    return this.apiClient.post('api/unity/change-password', payload).pipe(map(response => response));
  }

  uploadProfileImage(formData: FormData): Observable<any> {
    const url = '/api/system/profile-image-upload';
    return this.apiClient.upload(url, formData);
  }

    getAgentNOlist(obj:any): Observable<any> {
    const requestBody = {
      companyId: this.COMPANY_ID,
      userID: this.getCurrentUserId(),
      ...obj
    };

    return this.apiClient
      .get('api/system/agents-list', {
        params: requestBody,
      })
      .pipe(map(response => response.data));
  }
  getgroupsTypelist(): Observable<any> {
    const requestBody = {
      companyId: this.COMPANY_ID,
      userID: this.getCurrentUserId(),
    };

    return this.apiClient
      .get('api/system/group-types', {
        params: requestBody,
      })
      .pipe(map(response => response.data));
  }
  getAgentlist(): Observable<any> {
    const requestBody = {
      companyId: this.COMPANY_ID,
      userID: this.getCurrentUserId(),
    };

    return this.apiClient
      .get('api/system/agents-list-no-page', {
        params: requestBody,
      })
      .pipe(map(response => response.data));
  }
  createNewGroup(payload: any): Observable<any> {
    const requestBody = {
      ...payload,
      companyId: this.COMPANY_ID,
      // userID: this.getCurrentUserId()
    };

    return this.apiClient
      .post('api/system/create-group', requestBody)
      .pipe(map(response => response.data));
  }

  getGroupSlugSuggestion(groupName: string, suggestions = 5): Observable<any> {
    const params = {
      companyId: this.COMPANY_ID,
      userID: this.getCurrentUserId(),
      groupName,
      suggestions,
    };

    return this.apiClient
      .get('api/system/group-slug-suggestion', { params })
      .pipe(map(response => response.data));
  }

  getResourceSlugSuggestion(resourceName: string, suggestions = 5): Observable<any> {
    const params = {
      companyId: this.COMPANY_ID,
      userID: this.getCurrentUserId(),
      resource_name: resourceName,
      suggestions,
    };

    return this.apiClient
      .get('api/system/resource-slug-suggestion', { params })
      .pipe(map(response => response.data));
  }

  getgroupsMembers(AGENTS): Observable<any> {
    const requestBody = {
      companyId: this.COMPANY_ID,
      userID: this.getCurrentUserId(),
      groupName: AGENTS,
    };

    return this.apiClient
      .get('api/system/groups-user-has-assigned', {
        params: requestBody,
      })
      .pipe(map(response => response.data));
  }

  // remove-user-from-group
  removeFromGroup(payload: any): Observable<any> {
    const requestBody = {
      ...payload,
      companyId: this.COMPANY_ID,
      // userID: this.getCurrentUserId()
    };

    return this.apiClient
      .post('api/system/remove-user-from-group', requestBody)
      .pipe(map(response => response.data));
  }
  addMembersToGroups(payload: any): Observable<any> {
    const requestBody = {
      ...payload,
      companyId: this.COMPANY_ID,
      // userID: this.getCurrentUserId()
    };

    return this.apiClient
      .post('api/system/create-user-group', requestBody)
      .pipe(map(response => response.data));
  }
  getAllPermissions(groupId: any): Observable<any> {
  const params = {
    companyId: 'UNITYCRM0021',
    GroupID:groupId
  };

  return this.apiClient
    .get('api/system/resource-permission-detail', { params })
    .pipe(map(response => response));
}

updatePermission(id: any, body: any): Observable<any> {
  const url = `api/system/resource-permissions/update/${id}`;
  return this.apiClient
    .post(url, body)
    .pipe(map(response => response));
}

createPermission(body: any): Observable<any> {
  const url = `api/system/resource-permissions/create`;
  return this.apiClient
    .post(url, body)
    .pipe(map(response => response));
}

getStates(params: any): Observable<any> {
  return this.apiClient
    .get('api/system/getStates', { params })
    .pipe(map(response => response));
}

getCities(params: any): Observable<any> {
  return this.apiClient
    .get('api/system/getCities', { params })
    .pipe(map(response => response));
}

getZipCodes(params: any): Observable<any> {
  return this.apiClient
    .get('api/system/getZipCodes', { params })
    .pipe(map(response => response));
}

getZipCodeId(params: any): Observable<any> {
  return this.apiClient
    .get('api/system/getZipCodeId', { params })
    .pipe(map(response => response));
}
getMasterAgent(): Observable<any> {
  const params = {
    companyId: 'UNITYCRM0021',
    userID: this.getCurrentUserId()
  };

  return this.apiClient
    .get('api/system/masteragent', { params })
    .pipe(map(response => response));
}

getDistributorList1(): Observable<any> {
  const params = {
    companyId: 'UNITYCRM0021',
    userID: this.getCurrentUserId()
  };

  return this.apiClient
    .get('api/system/distributors', { params })
    .pipe(map(response => response));
}

getRetailers(): Observable<any> {
  const params = {
    companyId: 'UNITYCRM0021',
    userID: this.getCurrentUserId()
  };

  return this.apiClient
    .get('api/system/retailers', { params })
    .pipe(map(response => response));
}

CreateAgent(obj: any): Observable<any> {
  return this.apiClient
    .post('api/system/create-agent', obj)
    .pipe(map(response => response));
}

updateAgent1(obj: any, id: any): Observable<any> {
  return this.apiClient
    .put(`api/system/update-agent/${id}`, obj)
    .pipe(map(response => response));
}
updateGroupList(id: any, obj: any): Observable<any> {
  const url = `api/system/update-group/${id}`;
  return this.apiClient
    .put(url, obj)
    .pipe(map(response => response.data));
}

getAllAgentPermissions(userId: any): Observable<any> {
  const params: any = {
    companyId: 'UNITYCRM0021',
    agentId: userId,
  };
  return this.apiClient
    .get('api/system/resource-permission-detail', { params })
    .pipe(map(response => response));
}

getComboList(body?: any): Observable<any> {
  const params = body || {};

  return this.apiClient
    .get('api/product/getProductCombo', { params })
    .pipe(map(response => response.data));
}

getClients(obj?: any): Observable<any> {
  return this.apiClient
    .get('api/resource-security/clients', { params: obj })
    .pipe(map(response => response.data));
}
}
